import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import type { BarData } from '@mylighthouse/prism-ember/types/components/prism/data-bar';

interface GeneralListsListItemsListItemTotalSignature {
  Args: {
    backgroundColour: string;
    isLoading: boolean;
    itemTotal: number;
    subText: string;
    total: number;
  };
}

export default class GeneralListsListItemsListItemTotal extends Component<GeneralListsListItemsListItemTotalSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get formattedTotal(): string {
    const formattedTotal = this.hotelAndMarketService.formatRate(
      this.args.itemTotal,
    );

    return formattedTotal || '0';
  }

  get progressBarData(): BarData[] {
    return [
      {
        widthPercentage: this.widthPercentage,
        backgroundColor: this.args.backgroundColour,
      },
    ] as BarData[];
  }

  get widthPercentage(): number {
    return Math.floor((this.args.itemTotal / this.args.total) * 100);
  }

  <template>
    <div class="item-total">
      {{#if @isLoading}}
        <div class="total-number-loading-bar-container">
          <div class="table-loading-state-bar"></div>
        </div>
      {{else}}
        <h4>{{this.formattedTotal}}</h4>
      {{/if}}
      <div class="total-progress-bar">
        {{#if @isLoading}}
          <div class="progress-bar-loading-bar-container">
            <div class="table-loading-state-bar"></div>
          </div>
        {{else}}
          <PrismDataBar @data={{this.progressBarData}} />
        {{/if}}
      </div>
      <span class="list-item-subtext text-200--regular capitalize">
        {{@subText}}
      </span>
    </div>
  </template>
}
